import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type GetNoticeReq, type GetNoticesReq, getNotice, getNotices } from './api';

export const noticeQueryKey = createQueryKeys('notice', {
  notice: (params: GetNoticeReq) => ({
    queryFn: async () => {
      const response = await getNotice(params);
      return response;
    },
    queryKey: [params],
  }),
  notices: (params: GetNoticesReq) => ({
    queryFn: async () => {
      const response = await getNotices(params);
      return response;
    },
    queryKey: [params],
  }),
});
